<template>
  <div class="footer">
    <div class="swipe">
      <svg xmlns="http://www.w3.org/2000/svg" width="41" height="37" fill="#fff"><g id="_x31__1_"><g id="Dignity_LifesMoment_Mobile_1a-Copy_1_" transform="translate(-167 -579)"><g id="swipe_1_" transform="translate(167 580)"><path class="st0" d="M18.2 7.9C16.8 7.1 16 5.5 16 3.7 16 1.1 17.8-1 20-1s4 2.1 4 4.7c0 1.5-.6 2.9-1.7 3.8L21 6c.6-.5 1-1.4 1-2.3 0-1.5-.9-2.7-2-2.7s-2 1.2-2 2.7c0 1.1.5 2 1.2 2.5l-1 1.7z"/><path id="Fill-1_1_" class="st0" d="M38.2 5h-9.4c-.4 0-.8-.4-.8-1s.4-1 .8-1h9.4c.4 0 .8.4.8 1s-.4 1-.8 1"/><path id="Fill-3_1_" class="st0" d="M36.8 8c-.2 0-.4-.1-.6-.2-.3-.3-.3-.8 0-1.1L39 4l-2.7-2.6c-.3-.3-.3-.8 0-1.1.3-.3.9-.3 1.2 0l3.3 3.2c.3.3.3.8 0 1.1l-3.3 3.2c-.2.1-.5.2-.7.2"/><path id="Fill-4_1_" class="st0" d="M10.2 5H.8C.4 5 0 4.6 0 4s.4-1 .8-1h9.4c.4 0 .8.4.8 1s-.4 1-.8 1"/><path id="Fill-5_1_" class="st0" d="M4.2 8c-.2 0-.5-.1-.6-.2L.2 4.6c-.3-.3-.3-.8 0-1.1L3.5.3c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L2 4l2.7 2.6c.3.3.3.8 0 1.1-.1.2-.3.3-.5.3"/><path id="Fill-6_1_" class="st0" d="M11.4 20c-.6 0-1.3.2-1.7.7-.3.3-.3.8 0 1.1l10.7 11c1 1 2.3 1.6 3.7 1.6h3.5c3.7 0 6.8-3.1 6.8-7v-8.5c0-.9-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v.8c0 .4-.3.8-.8.8s-.6-.3-.6-.8v-2.3c0-.9-.7-1.6-1.5-1.6s-1.5.7-1.5 1.6v2.3c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8v-3.9c0-.9-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v3.9c0 .4-.3.8-.8.8s-.8-.3-.8-.8V8.1c0-.9-.7-1.6-1.5-1.6s-1.5.7-1.5 1.6v14.7c0 .3-.2.6-.4.7-.3.1-.6.1-.8-.1l-3.8-2.9c-.3-.3-.8-.5-1.4-.5zm16.3 16h-3.5c-1.8 0-3.5-.7-4.8-2L8.7 23c-.9-.9-.9-2.4 0-3.3 1.4-1.4 3.6-1.6 5.1-.4l2.6 2V8.1c0-1.7 1.4-3.1 3-3.1 1.7 0 3 1.4 3 3.1v5.1c.4-.3 1-.4 1.5-.4 1.3 0 2.4.9 2.8 2.1.5-.3 1.1-.5 1.7-.5 1.3 0 2.4.9 2.8 2.1.5-.3 1.1-.5 1.7-.5 1.7 0 3 1.4 3 3.1v8.5c.1 4.6-3.6 8.4-8.2 8.4z"/></g></g></g></svg>
      <p>Swipe through to see more</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileFooter',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
  position: absolute;
  bottom: 20px;
  pointer-events: none;
  transition: opacity 0.6s ease 1s;

  .hide-swipe & {
    opacity: 0;
  }

  p {
    margin-bottom: 0;
  }

  @include respond-to('medium') {
    display: none;
  }

  &__logo {
    display: flex;

    @include respond-to('medium') {
      display: none;
    }
  }

  &__sharing {
    display: flex;
    flex-direction: row;

    &--mobile {
      display: flex;
      flex-direction: column;
      position: absolute;
      height: 100vh;
      top: 0;
      right: 0;

      @include respond-to('medium') {
        display: none;
      }
    }

    &--desktop {
      display: none;

      @include respond-to('medium') {
        display: flex;
      }
    }

    /deep/ span {
      padding: 0 20px;
      cursor: pointer;

      &:last-child {
        padding-right: 0;
      }

       svg {
        opacity: 0.5;
        transition: opacity 0.2s ease-in-out;
      }

      &:hover {
         svg {
          opacity: 1;
        }
      }
    }
  }
  .swipe {
    position: relative;
    display: block;

    @include respond-to('medium') {
      display: none;
    }

    p {
      font-size: 12px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MobileFooter.vue